import { Action } from '@ngrx/store';

export enum StatusFilterAction {
  Set = '[StatusFilter] Set',
  Reset = '[StatusFilter] Reset',
  Sync = '[StatusFilter] Sync',
}

export class Set implements Action {
  readonly type = StatusFilterAction.Set;

  constructor(public payload: string) {}
}

export class Reset implements Action {
  readonly type = StatusFilterAction.Reset;
}

export class Sync implements Action {
  readonly type = StatusFilterAction.Sync;

  constructor(public payload: string[]) {}
}

export type StatusFilterActionType = Set | Reset | Sync;
